export default "__VITE_ASSET__Cb8I5eLn__"